import React, { useState } from 'react';
import { Box } from '@mui/material';

import { PropertyTextInput } from '@paragon/client-tools';
import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { downloadBillOfLading } from '../../actions/downloadActions';
import { useAppDispatch } from '../hooks';

export interface DownloadBillOfLadingDialogProps {
  readonly truckloadGuid: string;
}

export function DownloadBillOfLadingDialog(props: DownloadBillOfLadingDialogProps) {
  const dispatch = useAppDispatch();

  const [salesperson, setSalesperson] = useState<string | null>(null);
  const [soldToAddress, setSoldToAddress] = useState<string | null>(null);
  const [shipToAddress, setShipToAddress] = useState<string | null>(null);

  return (
    <Dialog
      title="Download Bill of Lading"
      open
      submitText="Download"
      onSubmit={() => {
        dispatch(downloadBillOfLading(props.truckloadGuid, salesperson, soldToAddress, shipToAddress));
        dispatch(closeCurrentPopup());
      }}
      onCancel={() => void dispatch(closeCurrentPopup())}
      contentSx={{ width: '400px', height: '400px' }}
    >
      <Box sx={{ mb: 1 }}>
        <PropertyTextInput
          property="Salesperson"
          value={salesperson ?? ''}
          submit={(updatedSalesperson) => setSalesperson(updatedSalesperson === '' ? null : updatedSalesperson)}
          fullWidth
        />
      </Box>
      <Box sx={{ mb: 1, height: '120px', overflow: 'auto' }}>
        <PropertyTextInput
          property="Sold to address"
          value={soldToAddress ?? ''}
          submit={(updatedSoldToAddress) => setSoldToAddress(updatedSoldToAddress === '' ? null : updatedSoldToAddress)}
          fullWidth
          multiline
        />
      </Box>
      <Box sx={{ mb: 1, height: '120px', overflow: 'auto' }}>
        <PropertyTextInput
          property="Ship to address"
          value={shipToAddress ?? ''}
          submit={(updatedShipToAddress) => setShipToAddress(updatedShipToAddress === '' ? null : updatedShipToAddress)}
          fullWidth
          multiline
        />
      </Box>
    </Dialog>
  );
}
